<template>
<div>
  <Loading :isLoading="isLoading" />
  <div>
    <p style="padding:10px 10px 0px 10px;font-size:20px;color:#810042;font-weight:700;font-family:Lato;">Solicitudes Incompletas</p>
  </div>
  <div class="py-2">
    <TableComponent :key="render" :columns="columns" :rows="rows" :rangeInput="true" :exportInput="true" />
  </div>
</div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from "vue";
import Loading from '@/components/Loading/VueLoading.vue';
import '@/assets/css/tailwind.css';
import TableComponent from "@/components/Forms/Tables/TableComponent";
import AdmissionRequest from "@/classes/AdmissionRequest.js";

//Iconos
import checkIcon from '@/assets/yes.svg'
import crossIcon from '@/assets/no.svg'

export default {
  name: 'SolicitudesAceptadas',

  setup() {
    let app = getCurrentInstance();
    const isLoading = ref(true);
    const apiToken = ref("");
    const admissionRequestObject = ref(null);
    
    let admissionRequestList = ref([]);
    let columns = ref([]);
    let rows = ref([]);
    let fields = ref([]);
    let render = ref(false);
    
    onMounted(async() => {
       app = app.appContext.config.globalProperties;
       apiToken.value = sessionStorage.getItem("login");
       admissionRequestObject.value = new AdmissionRequest();
       await getUnfinishedRequest(apiToken.value);
       getColumns();
       getRows();
       isLoading.value = false;
       render.value = true;
    });
    
    const getUnfinishedRequest = async(token) => {
        await admissionRequestObject.value.getUnfinishedRequest(token).then((response)=>{
          admissionRequestList.value = response.data.response.data.reverse();
        });
    }

    const getColumns = () => {
      if(admissionRequestList.value.length == 0){
        return;
      }

      columns.value = [
        { headerName: "RFC", field: 'rfc'},
        { headerName: "Nombre", field: 'nombre_completo' },
        { headerName: "Teléfono", field: 'telefono' },
        { headerName: "Celular", field: 'celular' },
        { headerName: "Correo", field: 'correo' },
        { headerName: "Fecha de registrado", field: 'fecha_registrado' },
        { headerName: "Proceso", field: 'proceso' },
        { headerName: "Tipo de cliente", field: 'tipo_cliente' },
        { headerName: "Organización", field: "organization" },
        { headerName: "Entidad", field: "entidad" },
        { headerName: "Identificacion", field: 'identificacion_oficial', cellRenderer: params => isCheckIcon(params) },
        { headerName: "Comprobante de domicilio", field: 'comprobante_domicilio', cellRenderer: params => isCheckIcon(params) },
        { headerName: "CURP", field: 'curp', cellRenderer: params => isCheckIcon(params) },
        { headerName: "Comprobante de ingreso", field: 'comprobante_ingresos', cellRenderer: params => isCheckIcon(params) },
        { headerName: "Ultimo estado de cuenta", field: 'ultimo_estado_cuenta_bancario', cellRenderer: params => isCheckIcon(params) },
      ];

      columns.value.forEach(element => {
        fields.value.push(element.field);
      });
    }

    const getRows = () => {
      if(admissionRequestList.value.length == 0){
        return;
      }

    admissionRequestList.value.filter((admission) => {
      rows.value.push(formatFields(admission));
    });

    }

    const isCheckIcon = (params) => {
      const value = params.value == "SI" ? `<img class="mx-auto" src=${checkIcon} />`:`<img class="mx-auto" src=${crossIcon} />`;
      return value;
    }

    const formatFields = (fields) => {
     return {
        rfc: fields["rfc"] || "",
        nombre_completo: fields["nombre_completo"] ? fields["nombre_completo"].toString().toUpperCase() : "NO CAPTURADO",
        telefono: fields["telefono"] ? app.$filters.formatPhone(fields["telefono"]) : "NO CAPTURADO",
        celular: fields["celular"] ? app.$filters.formatPhone(fields["celular"]) : "NO CAPTURADO",
        correo: fields["correo"] ? fields["correo"].toString().toLowerCase() : "NO CAPTURADO",
        fecha_registrado: fields["fecha_registrado"] ? app.$filters.formatDate(fields["fecha_registrado"]) : "NO CAPTURADO",
        proceso: fields["proceso"] ? app.$filters.requestStatus(fields["proceso"]) : "NO CAPTURADO",
        tipo_cliente: fields["tipo_cliente"] ? fields["tipo_cliente"].toString().toUpperCase() : "NO CAPTURADO",
        organization: (fields && fields.person && fields.person.user && fields.person.user.organizations && fields.person.user.organizations.join()) || "NO CAPTURADO",
        entidad: fields && fields["admission_information"] && fields["admission_information"]["workplace_attributes"] && fields["admission_information"]["workplace_attributes"]["state"] || "NO CAPTURADO",
        identificacion_oficial: fields["identificacion_oficial"] ? fields["identificacion_oficial"].toString().toUpperCase() : "NO CAPTURADO",
        comprobante_domicilio: fields["comprobante_domicilio"] ? fields["comprobante_domicilio"].toString().toUpperCase() : "NO CAPTURADO",
        comprobante_ingresos: fields["comprobante_ingresos"] ? fields["comprobante_ingresos"].toString().toUpperCase() : "NO CAPTURADO",
        ultimo_estado_cuenta_bancario: fields["ultimo_estado_cuenta_bancario"] ? fields["ultimo_estado_cuenta_bancario"].toString().toUpperCase() : "NO CAPTURADO",
      }
    }

    return {
      isLoading,
      columns,
      rows,
      render
    };
  },

  components: {
    Loading,
    TableComponent
  }
}
</script>